import { FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402 } from "@faire/retailer-settings/FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { IFourVariantXP } from "@faire/web-api--source/indigofair/settings/IFourVariantXP";

export const useSettingMobileLoggedOutNavUpdate = (): IFourVariantXP => {
  return useSetting(FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402);
};
export const useAssignSettingMobileLoggedOutNavUpdate = () =>
  useAssignSetting(FE_LOGGED_OUT_NAV_MOBILE_WEB_UPDATE_250402);
